import { PublicClientApplication, AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { msalConfig, loginRequest, tokenRequest, b2cPolicies, forgotPasswordRequest, myMSALObj } from './authConfig';
// import { store } from '@/store';
import store from '../store';
import router from '@/router';
// import { ActionTypes } from '@/store/modules/mainBlock/action-types';

let accountId = "";
let username = "";
export let accessToken = null;
export let selectedAccount = {};
let interactionInProgress = false;

myMSALObj.handleRedirectPromise().then((response) => {
    if (response) {
        localStorage.setItem('accessToken', response.accessToken);
            store.commit('prochip/setAccessToken', response.accessToken);

        const idTokenClaims = response.idTokenClaims;

        if (idTokenClaims.acr && idTokenClaims.acr.toUpperCase() === b2cPolicies.names.signUpSignIn.toUpperCase()) {
            setAccount(response.account);
        }
    }
}).catch((error) => {
    console.error('Error processing redirect response:', error);
});

function setAccount(account) {
    myMSALObj.setActiveAccount(account);
    selectedAccount = account;
    accountId = account.homeAccountId;
    username = account.username;
    localStorage.setItem("user", JSON.stringify(account.idTokenClaims));
}

export const getAccount = function selectAccount() {
    const currentAccounts = myMSALObj.getAllAccounts();

    if (currentAccounts.length < 1) {
        return;
    } else if (currentAccounts.length > 1) {
        const accounts = currentAccounts.filter(account => {
            const claims = account.idTokenClaims;
            if (!claims) {
                return false;
            }

            return (
                claims.acr?.toUpperCase() === b2cPolicies.names.signUpSignIn.toUpperCase() &&
                claims.iss?.toUpperCase().includes(b2cPolicies.authorityDomain.toUpperCase()) &&
                claims.aud === msalConfig.auth.clientId
            );
        });

        if (accounts.length === 1) {
            setAccount(accounts[0]);
        } else {
            signOut();
        }
    } else if (currentAccounts.length === 1) {
        setAccount(currentAccounts[0]);
    }
}

getAccount();

export const signIn = async function() {
    if (interactionInProgress) {
        return;
    }

    try {
        interactionInProgress = true;
        await myMSALObj.loginRedirect(loginRequest);
    } catch (error) {
        console.error('Error during sign-in:', error);
        if (error instanceof InteractionRequiredAuthError) {
            window.location.href = "https://www.microchip.com";
        } else {
            console.log(error);
        }
    } finally {
        interactionInProgress = false;
    }
};

function handleSuccessfulSignIn(account) {
    setAccount(account);
    passTokenToApi();
}

function deleteAllCookies() {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";

        const path = location.pathname;
        const pathParts = path.split('/');
        while (pathParts.length > 0) {
            pathParts.pop();
            const currentPath = pathParts.join('/') || '/';
            document.cookie = name + `=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${currentPath}`;
        }
    }
}

export const checkTokenExpiry = async function() {
    let newAccessToken = null;
    const currentAccessToken = localStorage.getItem('accessToken');
    const expiryTime = localStorage.getItem('tokenExpiry');
    const returnValue = localStorage.getItem("changePasswordReload");

    if (returnValue != null && returnValue === 'true') {
        signOut();
        window.location.href = process.env.VUE_APP_B2C_LOGOUT_URL;
        localStorage.removeItem("changePasswordReload");
    } else {
        const now = Date.now();
        if (currentAccessToken && expiryTime) {
            if (now >= parseInt(expiryTime)) {
                newAccessToken = await acquireTokenSilent(tokenRequest);
            } else {
                newAccessToken = currentAccessToken;
            }
        } else {
            newAccessToken = await acquireTokenSilent(tokenRequest);
        }
    }

    return newAccessToken;
};

export const acquireTokenSilent = async function(request) {
    try {
        const response = await myMSALObj.acquireTokenSilent(request);

        if (response.accessToken) {
            accessToken = response.accessToken;

            if (response.expiresOn) {
                localStorage.setItem('tokenExpiry', response.expiresOn.getTime().toString());
            } else {
                console.error("myMicrochip: Inside acquireTokenSilent fn. Token expiry is null or undefined. Setting it manually.");
                localStorage.setItem('tokenExpiry', (Date.now() + 3600 * 1000).toString());
            }

            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem("idtokenclaimsuser", JSON.stringify(response.account));
            setAccount(response.account);

            return response.accessToken;
        } else {
            throw new Error("No access token received");
        }
    } catch (error) {
        console.log("Silent token acquisition failed. Attempting redirect.\n", error);
        if (error instanceof InteractionRequiredAuthError) {
            return myMSALObj.acquireTokenRedirect(request);
        } else {
            console.log(error);
        }
    }
};

// Sign out and clean up session
export const signOut = function signOut() {
    deleteAllCookies();
    localStorage.removeItem("user");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("changePasswordReload");
    localStorage.clear();

    const logoutRequest = {
        postLogoutRedirectUri: msalConfig.auth.postLogoutRedirectUri,
    };
    myMSALObj.logoutRedirect(logoutRequest);
};

function passTokenToApi() {
    if (!accessToken) {
        acquireTokenSilent(tokenRequest)
            .then(newAccessToken => {
                if (newAccessToken) {
                    localStorage.setItem("accessToken2", newAccessToken);
                } else {
                    console.error("Failed to acquire token silently.");
                }
            })
            .catch((error) => {
                console.error("Error acquiring token silently: ", error);
            });
    } else {
        localStorage.setItem("accessToken2", accessToken);
    }
}

export const passwordChange = function() {
    const changePasswordRequest = {
        authority: msalConfig.auth.PasswordChangeUri,
        scopes: forgotPasswordRequest.scopes,
        loginHint: myMSALObj.getAccountByHomeId(accountId)?.username
    };
    myMSALObj.loginRedirect(changePasswordRequest);
};
